// A blank search goes back to the front page of the view ('.' resolves to /v/:hash).
export const searchTarget = (value: string | undefined): string => {
  const trimmed = value?.trim();
  return trimmed ? 's?q=' + encodeURIComponent(trimmed) : '.';
};
